package com.swetdot.swetgram.data.tasks

/** What the Tasks UI may know about step access. No raw health record crosses this boundary. */
enum class DailyStepsAccess {
    GRANTED,
    PERMISSION_REQUIRED,
    UNAVAILABLE,
}

enum class DailyStepsProvider {
    HEALTH_CONNECT,
    STEP_COUNTER,
}

enum class UnavailableStepReason {
    PERMISSION_DENIED,
    PERMISSION_REVOKED,
    PROVIDER_UNAVAILABLE,
}

/** The only health-shaped value used by common code: one total for one local calendar day. */
data class DailyStepsTotal(
    val localDate: String,
    val steps: Int,
    val measuredAt: String,
    val provider: DailyStepsProvider,
)

/**
 * Platform bridge for voluntary daily step tasks.
 *
 * Implementations must aggregate on-device and must never expose samples, locations, routes,
 * speed, or another health type to common code.
 */
interface DailyStepsSource {
    suspend fun access(): DailyStepsAccess
    suspend fun requestAccess(): DailyStepsAccess
    suspend fun readToday(): DailyStepsTotal?
}
